export function useCartorioCor() {
  const getBgCor = (cor: string): string => {
    const cores = {
      red: '#f44336',
      purple: '#9c27b0',
      blue: '#2196f3',
      cyan: '#00bcd4',
      teal: '#009688',
      green: '#4caf50',
      orange: '#ff9800',
      brown: '#795548',
      bluegray: '#607d8b',
      black: '#000000',
      lightblue: '#03a9f4',
      lightgreen: '#8bc34a',
    }

    if (cor && cor in cores) {
      return cores[cor as keyof typeof cores]
    }

    return '#808080'
  }

  const getCurrentCartorioCor = (): string => {
    const { getCurrentCartorio } = useAuthStorage()
    const currentCartorio = getCurrentCartorio()
    const cor = currentCartorio?.cor
    
    return cor ? getBgCor(cor) : '#000000'
  }

  return {
    getBgCor,
    getCurrentCartorioCor
  }
} 